// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { type RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { useQueryMileageLockSetting } from '../models/useQueryMileageLockSetting'

interface UseGetMileageLockSettingPresenterReturn {
  data: {
    mileageLockSetting: RequestMileageConfiguration | null
  }
  states: {
    isLoading: boolean
    isError: boolean
  }
}

export const useGetMileageLockSettingPresenter = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}): UseGetMileageLockSettingPresenterReturn => {
  const { mileageLockSetting, isLoading, isError } = useQueryMileageLockSetting(
    { enabled }
  )

  return {
    data: {
      mileageLockSetting,
    },
    states: {
      isLoading,
      isError,
    },
  }
}
